<template>
  <div v-if="!readonly" class="action" style="display: table-caption">
    <input
      :value="value"
      @input="change($event)"
      @mousewheel.stop=""
      @pointerdown.stop=""
      @pointermove.stop=""
    />
    <b-button-group class="mt-1">
      <b-button
        size="sm"
        @click="create('number')"
        class="btn-success"
        title="Create Number"
      >
        <font-awesome-icon icon="plus-circle" />
      </b-button>
      <b-button
        size="sm"
        @click="create('boolean')"
        class="btn-info ml-1"
        title="Create Bool"
      >
        <font-awesome-icon icon="plus-circle" />
      </b-button>
      <b-button
        size="sm"
        @click="remove"
        class="btn-warning ml-1"
        title="Delete"
      >
        <font-awesome-icon icon="minus-circle" />
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: ['emitter', 'createSocket', 'removeSocket', 'readonly'],

  data() {
    return {
      value: '',
    }
  },

  methods: {
    change(e) {
      this.value = e.target.value
    },

    create(type) {
      if (this.value) {
        this.createSocket(this.value, type)
        this.value = ''
      }
    },

    remove() {
      if (this.value) {
        this.removeSocket(this.value)
        this.value = ''
      }
    },
  },
}
</script>
